import { type RovoResponseTone } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

// eslint-disable-next-line import/extensions
import collaborativeIllustration from './assets/collaborative.svg';
// eslint-disable-next-line import/extensions
import creativeIllustration from './assets/creative.svg';
// eslint-disable-next-line import/extensions
import empatheticIllustration from './assets/empathetic.svg';
// eslint-disable-next-line import/extensions
import professionalIllustration from './assets/professional.svg';

/** Illustration override for a preset. When absent the mode's default illustration is kept. */
export type GreetingIllustration = { src?: string; srcDark?: string };

/**
 * Per-preset greeting illustrations, keyed by tone. Each is a single
 * theme-agnostic SVG (content design: collaborative = "Project Icon",
 * professional = "Summarize", creative = "Brainstorm", empathetic = "Create");
 * `CustomGreetingCard` falls back to `src` in dark mode when `srcDark` is unset.
 */
export const GREETING_ILLUSTRATIONS: Partial<Record<RovoResponseTone, GreetingIllustration>> = {
	rovo_default: { src: collaborativeIllustration },
	professional: { src: professionalIllustration },
	creative: { src: creativeIllustration },
	empathetic: { src: empatheticIllustration },
};
